<div class="modal-container">
  <div class="modal-header">
    <span
      >{{ 'modal.group_action.warning_msg1' | translate }} {{ data.action
      }}{{ 'modal.group_action.warning_msg2' | translate }}</span
    >
  </div>
  <div class="seperator">
    <hr />
  </div>
  <div class="modal-body" *ngIf="company$ | async; let company">
    <span *ngIf="!errorMessage && data.leaving">
      {{ 'modal.group_action.warning_leave_msg1' | translate }}
      <span class="company-name">{{
        company.name || 'Adorsys GmbH & Co.KG'
      }}</span
      >{{ 'modal.group_action.warning_leave_msg2' | translate }}
    </span>
    <span *ngIf="!errorMessage && !data.leaving">
      {{ 'modal.group_action.warning_delete_msg1' | translate }}
      <span class="company-name">{{
        company.name || 'Adorsys GmbH & Co.KG'
      }}</span
      >{{ 'modal.group_action.warning_delete_msg2' | translate }}
    </span>
    <span class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </span>
    <div class="modal-content">
      <div class="buttons">
        <app-button
          [small]="true"
          [title]="'modal.group_action.cancel' | translate"
          (click)="abortModal()"
        ></app-button>
        <app-button
          [redAlert]="true"
          [small]="true"
          [title]="data.buttonTitle"
          (click)="deleteGroup(company.id)"
        ></app-button>
      </div>
    </div>
  </div>
</div>
